module.exports = __webpack_public_path__ + "static/img/reward-bg.2949968d.webp";